export default "__VITE_ASSET__$e7TaNc$__"